module.exports = __webpack_public_path__ + "static/rf-screenshot-reviews-282b735dac0e2b390bb020f3656f2072.jpg";